import _defineProperty from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { createAssertionFunction } from '@aws-amplify/core/internals/utils'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var TokenProviderErrorCode;

(function (TokenProviderErrorCode) {
  TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})(TokenProviderErrorCode || (TokenProviderErrorCode = {}));

var tokenValidationErrorMap = _defineProperty({}, TokenProviderErrorCode.InvalidAuthTokens, {
  message: 'Invalid tokens.',
  recoverySuggestion: 'Make sure the tokens are valid.'
});

var assert = createAssertionFunction(tokenValidationErrorMap);
export { TokenProviderErrorCode, assert };